import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum'
import { APP_VERSION } from 'app-constants'

declare global {
  interface Window {
    analytics: any
    DD_LOGS: any
    rudderanalytics: any
  }
}

export const initializeDatadogRum = ({
  applicationId,
  clientToken,
  service,
  env,
}: RumInitConfiguration) => {
  datadogRum.init({
    applicationId,
    clientToken,
    service,
    env,
    version: APP_VERSION,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: [/.*graphql.*/],
    defaultPrivacyLevel: 'mask-user-input',
  })
}

export const initializeDatadog = (key) => {
  if (window.DD_LOGS && key) {
    window.DD_LOGS.init({ clientToken: key, forwardErrorsToLogs: true })
    window.DD_LOGS.addLoggerGlobalContext('service', 'acorns-hello-web')
  }
}

export function initializeAnalytics(token) {
  const analytics = (window.analytics = window.analytics || [])

  if (analytics.initialize) {
    return analytics
  }

  analytics.invoked = true

  // A list of the methods in Analytics.js to stub.
  analytics.methods = [
    'trackSubmit',
    'trackClick',
    'trackLink',
    'trackForm',
    'pageview',
    'identify',
    'reset',
    'group',
    'track',
    'ready',
    'alias',
    'debug',
    'page',
    'once',
    'off',
    'on',
  ]

  analytics.factory = function (method) {
    return function () {
      // Disabling ESLint for this line for no reason other than the code existed like this before this ESLint rule went into effect.
      // If you're here from the future, please resolve this ESLint error!
      // eslint-disable-next-line prefer-rest-params
      const args = Array.prototype.slice.call(arguments)
      args.unshift(method)
      analytics.push(args)
      return analytics
    }
  }

  for (let i = 0; i < analytics.methods.length; i++) {
    const key = analytics.methods[i]
    analytics[key] = analytics.factory(key)
  }

  analytics.load = function (key, options) {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js'
    const first = document.getElementsByTagName('script')[0]
    first ? first.parentNode.insertBefore(script, first) : document.body.appendChild(script)
    analytics._loadOptions = options
  }

  // Add a version to keep track of what's in the wild.
  analytics.SNIPPET_VERSION = '4.1.0'

  analytics.load(token)
}
